import { GtmSender } from './GtmSender';

export class AuthStepConversionSend {
    private location: Location;
    private prefix: string = 'lp_auth_step';

    constructor(location: Location) {
        this.location = location;
    }

    public send(step: string): void {
        const eventName = this.createEventName(step);
        GtmSender.fireMarketing(eventName);
    }

    private createEventName(step: string): string {
        const pathNameData = this.location.pathname.split('/');
        const arrSize = pathNameData.length;
        const lpType = pathNameData[arrSize - 1];
        const landingName = pathNameData[arrSize - 2];
        return `${this.prefix}_${step}_type_${lpType}_name_${landingName}`;
    }
}
